import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { alpha } from "@mui/material/styles";

import { ReactComponent as JKLogo } from "_assets/images/jk.svg";

import Login from "./Login";

const Auth = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2,
        backgroundColor: "background.default",
        backgroundImage: (theme) =>
          `radial-gradient(circle at 50% -10%, ${alpha(
            theme.palette.primary.main,
            0.14
          )} 0%, ${alpha(theme.palette.primary.main, 0)} 55%)`,
      }}
    >
      <Card
        sx={{
          width: "100%",
          maxWidth: 420,
          p: { xs: 3, sm: 4 },
          boxShadow: (theme) => theme.shadows[8],
        }}
      >
        <Stack spacing={3} alignItems="center">
          <Box sx={{ "& svg": { width: 72, height: 72, display: "block" } }}>
            <JKLogo />
          </Box>

          <Stack spacing={0.5} alignItems="center">
            <Typography variant="h5" sx={{ fontWeight: 700 }}>
              Welcome back
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ textAlign: "center" }}
            >
              Sign in to continue to the MSFA admin dashboard
            </Typography>
          </Stack>

          <Login />
        </Stack>
      </Card>
    </Box>
  );
};

export default Auth;
